package navigation.root.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import ui.home.HomeScreen

object HomeScreenNav : Screen {
    @Composable
    override fun Content() {
        val homeScreenModel = koinScreenModel<HomeScreenModel>()
        val homeState by homeScreenModel.state.collectAsState()

        HomeScreen(
            state = homeState,
            onEvent = homeScreenModel::onEvent,
            toastManager = homeScreenModel.toastManager,
            loadingManager = homeScreenModel.loadingManager,
        )
    }
}
